import { useCallback, useEffect, useState } from "react";

const TODO_STATUS_BATCH_DELAY = 3000;

let ordinalMap: Record<string, string> = {};

let ordinalMapSubscriptions = new Set<() => void>();

function subscribeToOrdinalMap(
  callback: (ordinalMap: Record<string, string>) => void
) {
  const cb = () => callback(ordinalMap);
  ordinalMapSubscriptions.add(cb);
  return () => {
    ordinalMapSubscriptions.delete(cb);
  };
}

function useOrdinalMap() {
  const [state, setState] = useState<Record<string, string>>(ordinalMap);
  useEffect(() => {
    return subscribeToOrdinalMap((newOrdinalMap) => {
      setState(newOrdinalMap);
    });
  }, []);
  return state;
}
export function useTodoSorter() {
  const ordinalMap = useOrdinalMap();
  return useCallback(
    (
      a:
        | {
            id: string;
            ordinal: string;
          }
        | undefined,
      b:
        | {
            id: string;
            ordinal: string;
          }
        | undefined
    ) => {
      if (!a || !b) return 0;

      const aOrdinal = ordinalMap[a.id] ?? a.ordinal;
      const bOrdinal = ordinalMap[b.id] ?? b.ordinal;
      if (!aOrdinal || !bOrdinal) return 0;
      if (aOrdinal === bOrdinal) {
        return 0;
      }
      return bOrdinal < aOrdinal ? -1 : 1;
    },
    [ordinalMap]
  );
}
function notifyOrdinalMapSubscriptions() {
  for (const callback of ordinalMapSubscriptions) {
    callback();
  }
}

let clearOrdinalMapTimeout: NodeJS.Timeout | null = null;
export function clearOrdinalMap() {
  ordinalMap = {};
  clearOrdinalMapTimeout = null;

  notifyOrdinalMapSubscriptions();
}
export function setOrdinalMap(todoId: string, ordinal: string) {
  if (clearOrdinalMapTimeout) {
    clearTimeout(clearOrdinalMapTimeout);
  }
  clearOrdinalMapTimeout = setTimeout(() => {
    clearOrdinalMap();
  }, TODO_STATUS_BATCH_DELAY);

  if (!ordinalMap[todoId]) {
    ordinalMap = { ...ordinalMap, [todoId]: ordinal };
  }

  notifyOrdinalMapSubscriptions();
}
